if (!customElements.get('form-error-handling')) {
  class formErrorHandling extends HTMLElement {
    constructor() {
      super();
      document.addEventListener('DOMContentLoaded', () => {
        this.init();
      });
    }
    init() {
      this.button = this.querySelector('input[type="button"], button[type="button"]');
      // console.log(this.button,"==========");
      this.buttonSubmit = this.querySelector('input[type="submit"], button[type="submit"], button[data-submit]');
      // console.log(this.buttonSubmit,"==========");
      this.privacyBox = this.querySelector('.policy-error__checkbox');
      // console.log(this.privacyBox,"==========");
      this.notice = this.querySelector('.notice2.hide, .notice3.hide');
      // console.log(this.button, "BEFORE CLICK");
      this.button?.addEventListener('click', () => {
        // console.log(this.button, "AFTER CLICK");
        if (this.privacyBox && this.privacyBox.checked && this.buttonSubmit) {
          this.buttonSubmit.click();
        } else {
          if (this.notice) {
            this.notice.style.display = 'block';
          }
        }
      });
    }
  }
  customElements.define('form-error-handling', formErrorHandling);
}